export function getUrlParameterParts (value) {
  const text = String(value || '')
  const parts = []
  const parameterPattern = /(^|\/)(:[^/]+)/g
  let cursor = 0
  let match = parameterPattern.exec(text)

  while (match) {
    const parameterStart = match.index + match[1].length
    if (parameterStart > cursor) {
      parts.push({ text: text.slice(cursor, parameterStart), dynamic: false })
    }
    parts.push({ text: match[2], dynamic: true })
    cursor = parameterStart + match[2].length
    match = parameterPattern.exec(text)
  }

  if (cursor < text.length || parts.length === 0) {
    parts.push({ text: text.slice(cursor), dynamic: false })
  }

  return parts
}

export function isGroupedUrlNode (node) {
  return [node.name, node.path, node.pathname]
    .filter(Boolean)
    .some(value => /(^|\/):[^/]+/.test(String(value)))
}

export function getGroupedUrlCount (node) {
  return Number(node.urlCount) || 0
}

export function hasGroupedUrls (node) {
  return isGroupedUrlNode(node) && getGroupedUrlCount(node) > 0
}

export function getNodeInspectionInfo (node) {
  const inspection = node.schemaInspection
  const hasInspectionContainer = Object.prototype.hasOwnProperty.call(node, 'schemaInspection')
  const hasDirectInspectionData = ['exists', 'score']
    .some(key => Object.prototype.hasOwnProperty.call(node, key))

  if (hasInspectionContainer && !inspection) {
    return {
      available: false,
      schemaTagExists: false,
      geoScore: null
    }
  }

  const schemaTagExists = inspection && inspection.exists != null
    ? inspection.exists
    : node.exists
  const geoScore = inspection && inspection.score != null
    ? inspection.score
    : node.score

  if (hasInspectionContainer || hasDirectInspectionData) {
    if (schemaTagExists == null && geoScore == null) {
      return {
        available: false,
        schemaTagExists: false,
        geoScore: null
      }
    }

    return {
      available: true,
      schemaTagExists: Boolean(schemaTagExists),
      geoScore: geoScore != null ? Number(geoScore) : '-'
    }
  }

  return {
    available: false,
    schemaTagExists: false,
    geoScore: null
  }
}

export function isNodeInspectionLoading (node) {
  const inspection = node.schemaInspection
  const status = (inspection && (inspection.reportStatus || inspection.status)) || node.reportStatus || node.status
  return Boolean(node.schemaInspectionLoading || (inspection && inspection.loading) || status === 'ing')
}

export function shouldShowNodeInfo (node) {
  return getNodeInspectionInfo(node).available || isNodeInspectionLoading(node)
}

export function getNormalizedGeoScore (node) {
  const score = Number(getNodeInspectionInfo(node).geoScore)
  return Number.isFinite(score)
    ? Math.min(100, Math.max(0, score))
    : 0
}

export function getGeoScoreColor (node) {
  const score = getNormalizedGeoScore(node)

  if (score <= 20) return '#d94b4b'
  if (score <= 40) return '#df7b22'
  if (score <= 60) return '#c49a00'
  if (score <= 80) return '#9aa210'
  return '#57AB00'
}
